<svelte:head>
  <title>Users | A Good Thing</title>
</svelte:head>

<nav class="level">
  <!-- Left side -->
  <div class="level-left">
    <div class="level-item">
      <h2 class="title">Users</h2>
    </div>
  </div>

  <!-- Right side -->
  <div class="level-right">
    <SearchInput bind:value={searchTerm}/>
  </div>
</nav>

<div class="level">
  <div class="level-left">
    <div class="level-item">
      <p class="has-text-grey-light is-size-7">
        {count} records
      </p>
    </div>
  </div>
</div>

<table class="table is-fullwidth is-hoverable">
  <thead>
    <tr>
      <th class="has-text-left">Email  <SortIcon field='id' {sortField} {sortAsc} on:toggle={(ev) => toggleSort(ev.detail.field)}/></th>
      <th class="has-text-left">First name <SortIcon field='data.firstName' {sortField} {sortAsc} on:toggle={(ev) => toggleSort(ev.detail.field)}/></th>
      <th class="has-text-left">Last name <SortIcon field='data.lastName' {sortField} {sortAsc} on:toggle={(ev) => toggleSort(ev.detail.field)}/></th>
      <th class="has-text-left">Created <SortIcon field='data.created' {sortField} {sortAsc} on:toggle={(ev) => toggleSort(ev.detail.field)}/></th>
      <th />
    </tr>
  </thead>
  <tbody>
    {#each items as item}
      <tr>
        <td>
          <div
            class="is-flex is-flex-direction-row align-items is-align-items-center">
            <a href={$url('../' + item.id)}>{item.id}</a>
          </div>
        </td>
        <td>
          <div
            class="is-flex is-flex-direction-row align-items is-align-items-center">
            {item.data.firstName}
          </div>
        </td>
        <td>
          <div
            class="is-flex is-flex-direction-row align-items is-align-items-center">
            {item.data.lastName}
          </div>
        </td>
        <td>
          <div
            class="is-flex is-flex-direction-row align-items is-align-items-center"
          >
            {dayjs(item.data.created).format('YYYY/MM/DD HH:mm')}
          </div>
        </td>
        <td>
          <div
            class="is-flex is-flex-direction-row align-items is-align-items-center">
          </div>
        </td>
      </tr>
    {/each}
  </tbody>
</table>

<script lang="ts">
  import _ from "lodash";
  import dayjs from "dayjs";
  import { url } from "@sveltech/routify";
  import SearchInput from "../../_components/SearchInput.svelte";
  import SortIcon from "../../_components/SortIcon.svelte";
  import { appState } from "../../../lib/appState";

  let allItems: User_v1_Doc[] = [];
  let delegatedCompanies : string[] | undefined = [];

  let firebase = window.firebase;

  let searchTerm = '';
  let sortField = '';
  let sortAsc = true;
 
  $: items = sort(sortField, sortAsc, filter( filterByCompanies(allItems, delegatedCompanies), searchTerm));

  $: count = items.length;

  getSimple();
  getDelegatedCompanies();

  async function getSimple() {
    firebase
      .firestore()
      .collection("users_v1")
      .onSnapshot((snap) => {
        allItems = snap.docs.map((doc) => ({ id: doc.id, data: doc.data() } as User_v1_Doc));
      });

  }

  function filter(_allItems :User_v1_Doc[] , _searchTerm : string) : User_v1_Doc[] {
    if (!_searchTerm) {
      return _allItems;
    }

    return _.filter(_allItems, (item) => {
      return item.id.toLowerCase().includes(_searchTerm.toLowerCase()) ||
             (item.data.firstName && item.data.firstName.toLowerCase().includes(_searchTerm.toLowerCase())) ||
             (item.data.lastName && item.data.lastName.toLowerCase().includes(_searchTerm.toLowerCase()));
    }) as User_v1_Doc[];
  }

  function filterByCompanies(
    _allItems: User_v1_Doc[],
    _companies: string[] | undefined
  ): User_v1_Doc[] {
    if (!_companies) {
      return _allItems;
    }

    return _.filter(_allItems, (item) => {
      return item.data.company && _companies.includes(item.data.company);
    }) as User_v1_Doc[];
  }


  function sort(_sortField :string, _sortAsc :boolean, _items:User_v1_Doc[]) {
    return _.orderBy(_items, _sortField, _sortAsc ? 'asc' : 'desc');
  }

  function toggleSort(field :string) {
    sortField = field;
    sortAsc = !sortAsc;
  }

  async function getDelegatedCompanies() {
    if($appState.user?.isDelegatedAdmin && $appState.user?.delegatedAdminTag) {
      firebase
        .firestore()
        .collection("companies_v1")
        .where("tags", "array-contains", $appState.user.delegatedAdminTag)
        .onSnapshot((snap) => {
          delegatedCompanies = snap.docs.map(
            (doc) => (doc.id)
          );
        });
    }
    else if ($appState.user?.isFullAdmin) {
      delegatedCompanies = undefined;
    }
    else {
      delegatedCompanies = [];
    }
  }

</script>
